<template>
  <div class="container_PColapsable">
    <div :class="['titleContainer_PColapsable', classHr]">
      <div class="title_PColapsable">
        <slot name="title"></slot>
      </div>
      <div class="colaps_PColapsable" @click="onClickColapsable">
        <PIcon
          icon="expand_less"
          type="material"
          color="#b7b7b7"
          size="22"
          v-if="!valueLocal"
        ></PIcon>
        <PIcon icon="expand_more" type="material" color="#b7b7b7" size="22" v-else></PIcon>
      </div>
    </div>

    <div class="content_PColapsable" v-show="!valueLocal">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: { PIcon },
})
export class PColapsable extends Vue {
  @Prop({ required: false }) value!: boolean;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = this.value;
  }
  @Prop({ required: false, default: "gray" }) variant!: "gray" | "yellow";
  valueLocal = false;
  get classHr(): string {
    return this.variant + "Hr_PColapsable";
  }

  onClickColapsable(): void {
    this.valueLocal = !this.valueLocal;
    this.$emit("change", this.valueLocal);
  }
}
export default PColapsable;
</script>
<style scoped>
.titleContainer_PColapsable {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
}
.title_PColapsable {
  font-size: 14px;
  font-weight: bold;
  color: var(--secundario-prosegur-claro);
  text-transform: uppercase;
}
.grayHr_PColapsable {
  border-bottom: 1px solid #ccc;
}
.yellowHr_PColapsable {
  border-bottom: 1px solid var(--amarillo-prosegur);
}
.colaps_PColapsable {
  cursor: pointer;
}
.content_PColapsable {
  padding: 0.5rem 0;
}
</style>
